import React from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../network/ApiCall';
import { useTranslation } from 'react-i18next';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import translation from '../../i18n/en';

const UsersTable = () => {

  const { t } = useTranslation();

  const gridStyle = { minHeight: 550 };

  const getUsers = async ({ skip, limit, sortInfo, filterValue }) => {
    const sortData = sortInfo ?? null;
    const result = await axiosInstance.get("/account", {
      params: {
        start: skip,
        length: limit,
        filter: encodeURIComponent(JSON.stringify(filterValue)),
        sort: encodeURIComponent(JSON.stringify(sortData))
      }
    })

    const data = result.data.data;
    const total = result.data.recordsTotal;
    return { data, count: parseInt(total) }

  }

  const filterValue = [
    { name: 'email', operator: 'contains', type: 'string', value: '' },
    { name: 'username', operator: 'contains', type: 'string', value: '' },
    { name: 'name', operator: 'contains', type: 'string', value: '' },
    { name: 'status', operator: 'contains', type: 'string', value: '' },
  ];

  const roleFilterSources = Object.keys(translation.role).map((key) =>
    ({ id: key, label: t('role:' + key) }))

  const statusFilterSources =
    [
      { id: "ACTIVE", label: t('status:ACTIVE') },
      { id: "DISABLED", label: t('status:DISABLED') }
    ]

  const columns = [
    {
      name: 'username',
      header: t('users:lblUsername'),
      sortable: true,
      defaultFlex: 1,
      render: ({ data }) => <Link to={`/app/users/edit/${data.id}`}>{data.username}</Link>
    },
    {
      name: 'email',
      header: t('users:lblEmail'),
      sortable: true,
      defaultFlex: 1,
    },
    { name: 'name', header: t('users:lblName'), sortable: true, defaultFlex: 1 },
    {
      name: 'roles',
      header: t('users:lblRoles'),
      sortable: true,
      defaultFlex: 1,
      render: ({ value }) => value.map((role) => t('role:' + role)).join(', '),
      filterEditor: SelectFilter,
      filterEditorProps: {
        placeholder: 'All',
        dataSource: roleFilterSources
      },
    },
    {
      name: 'status',
      header: t('users:lblStatus'),
      sortable: true,
      defaultFlex: 1,
      render: ({ value }) => t('status:' + value),
      filterEditor: SelectFilter,
      filterEditorProps: {
        dataSource: statusFilterSources
      },
    },
  ]

  return (

    <div className="card h-md-100">
      <div className="card-header bg-light ">
        <div className="row">
          <div className="col">
            <h4>{t('users:hdgHeading')}</h4>
          </div>
        </div>

      </div>
      <div className="card-body p-1">

        <>

          <ReactDataGrid
            idProperty="id"
            style={gridStyle}
            columns={columns}
            defaultFilterValue={filterValue}
            dataSource={getUsers}
            pagination
            defaultLimit={10}
          />
        </>

      </div>
    </div>);
}

export default UsersTable;